import { AppState, useAppSelector } from '@redux/store';

export const useRightTeamSpeakerId = (showId: string) =>
  useAppSelector(
    ({ shows }: AppState) => shows.byId[showId]?.rightTeamSpeakerId,
  );

export const useLeftTeamSpeakerId = (showId: string) =>
  useAppSelector(
    ({ shows }: AppState) => shows.byId[showId]?.leftTeamSpeakerId,
  );

export const useSpeakerDataById = (speakerId: string | null) =>
  useAppSelector(({ speakers }: AppState) => {
    if (!speakerId) {
      return null;
    }

    return speakers.byId[speakerId];
  });
